import { render, staticRenderFns } from "./cancellation.vue?vue&type=template&id=39a88e5b&scoped=true&"
import script from "./cancellation.vue?vue&type=script&lang=js&"
export * from "./cancellation.vue?vue&type=script&lang=js&"
import style0 from "./cancellation.vue?vue&type=style&index=0&id=39a88e5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a88e5b",
  null
  
)

export default component.exports